<template lang="pug">
  container.px-15(:width="row.width", :class="[widthClass, marginClass]")
    .rich-text__body.children-mt-1em.links-hover-text-app-text(v-html="row.text", :class="textClass")
    //- footer links...
    wp-link.my-24.mr-24.inline-block(v-if="row.footer_links", v-for="(item, i) in row.footer_links", :link="item.link", :key="i")
        link-with-arrow
          span(v-html="item.link.title")
</template>

<script>
import Container from '@/components/Container'
import LinkWithArrow from '@/components/LinkWithArrow'
export default {
  name: 'RichText',
  props: ['row'],
  computed: {
    isArticle () {
      return this.row.acf_fc_layout === 'text_article'
    },
    width () {
      return (this.row && this.row.width) || 'xl'
    },
    widthClass () {
      // Container.vue width is applied @ md !
      return this.width === 'xl' ? 'sm-w-xl' : 'sm-w-md'
    },
    marginClass () {
      const w = this.width
      return this.isArticle ? 'mt-60 mb-100'
        : {
          'mt-100 mb-120 md-mb-200': w === 'xl',
          'mt-82 mb-120 md-mb-180': w === 'md',
          'mt-30 mb-120 md-mb-164': w === 'sm'
        }
    },
    textClass () {
      const w = this.width
      const sz = this.row.font_size
      const smll = w !== 'xl' && sz !== 'md'
      return this.isArticle ? {
        // article
        'text-21 md-text-46 leading-nrml tracking-tight': sz === 'lg',
        'text-21 md-text-46 leading-xs tracking-tight': w === 'xl' && sz === 'lg',
        'text-21 md-text-24 leading-lg': sz === 'md' || (sz === 'sm' && w === 'xl'),
        'text-16 md-text-18 leading-lg': sz === 'sm'
      } : {
        // page
        'text-18 md-text-24 leading-xl': !smll,
        'text-15 md-text-17': smll
      }
    }
  },
  components: { Container, LinkWithArrow }
}
</script>

<style>
@import '../../style/_settings.css';

.rich-text__body{
  /* <h> tags in the_content - match Flx__Header.vue */
  & :--heading{
    font-size: 2.4rem;
    text-align: center;
    margin: 5.3rem auto 5rem;
  }

  /* narrow screens */
  @media (--bkpt-xs-only) {
    & [style*="text-align: justify"] {
      text-align:left !important;
    }
  }
}

</style>
